import type { ImgWebConfig } from '../types';

export const imgWebConfig: ImgWebConfig = {
  hostUrlDev: 'https://image-assets-server-dot-cms-headless-gae.ew.r.appspot.com/',
  hostUrlProd: 'https://tikalcasino{apiVersion}.com/'
};
